import type { TClientUserRes } from 'api/swagger/index.ts';
import { createStore } from 'shared/stores/create-store';

type TState = {
  clientUser?: TClientUserRes;
  isAuth: boolean;
};

type TActions = {
  setAuth: (user: TClientUserRes) => void;
  clearAuth: () => void;
};

export const useClientAuthStore = createStore<TState & TActions>(
  (set) => ({
    clientUser: undefined,
    isAuth: false,
    setAuth: (clientUser: TClientUserRes) => set(() => ({ clientUser, isAuth: true })),
    clearAuth: () => set(() => ({ clientUser: undefined, isAuth: false })),
  }),
  'client-auth-store',
);
